import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M12,22a2,2,0,0,1-2-2,5.963,5.963,0,0,0-5.957-5.957,2,2,0,1,1-.043-4,5.973,5.973,0,0,0,6-5.957A2.022,2.022,0,0,1,12,2a2,2,0,0,1,2,2,5.982,5.982,0,0,0,5.957,6.043H20a2,2,0,0,1,0,4A5.973,5.973,0,0,0,14,20,2,2,0,0,1,12,22ZM12,4.086a7.965,7.965,0,0,1-7.957,7.957A7.965,7.965,0,0,1,12,20a7.965,7.965,0,0,1,7.957-7.957h0A7.965,7.965,0,0,1,12,4.086Z"/><path d="M20,30a2,2,0,0,1-2-2,1.883,1.883,0,0,0-1.881-1.881H16a2,2,0,0,1,0-4h.119A1.883,1.883,0,0,0,18,20.238V20a2,2,0,0,1,4,0v.238a1.883,1.883,0,0,0,1.881,1.881H24a2,2,0,0,1,0,4h-.119A1.883,1.883,0,0,0,22,28,2,2,0,0,1,20,30Zm-4-5.881h.119A3.885,3.885,0,0,1,20,28a3.885,3.885,0,0,1,3.881-3.881h0A3.885,3.885,0,0,1,20,20.238a3.885,3.885,0,0,1-3.881,3.881Z"/><path d="M26.5,20A3.5,3.5,0,1,1,30,16.5,3.5,3.5,0,0,1,26.5,20Zm0-5A1.5,1.5,0,1,0,28,16.5,1.5,1.5,0,0,0,26.5,15Z"/>';
export var SparkleOutlineSVG = function SparkleOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
SparkleOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(SparkleOutlineSVG);